import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from '../components/common/DataTable';
import MessageBox from "../components/common/CustomMessageBox";
import CustomDelete from '../components/common/CustomDeleteAlert';
import CustomModal from "../components/common/CustomModal";
import Createexportshipement from "../components/exportshipement/createexportshipement";
import UpdateExportshipement from "../components/exportshipement/UpdateExportshipement";
import { DELETE_EXPORT_SHIPMENT, LIST_ALL_EXPORT_SHIPMENT } from "../services/apiRoutes";
import axios from "axios";
import { formatDate, getCIFFOBList, getCountries, getCurrencyList, getCustumersList, getPaymentMethod, getColorPlate, getPortMasters, getShipmentTypes, getSuppliersList, getColorById } from "../services/CommonServices";
import { AuthContext } from "../context/AuthContext";
import CustomLoader from "../components/common/CustomLoader";
import CustomFilter from "../components/common/CustomFilter";
import CustomTextField from "../components/common/CustomTextField";
import CustomAutocomplete from "../components/common/CustomAutoComplete";
import CustomButton from "../components/common/CustomButton";
import { ClearRounded, } from "@mui/icons-material";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import CustomStatus from "../components/common/CustomStatus";
import { genericPost } from "../services/authServices";
import { hasEditPermission, hasDeletePermission } from '../services/CommonServices'
import { useLocation } from "react-router-dom";
import { useCompanyDateFormat } from "../constants/useCompanyDateFormat";
import CustomDataTable from "../components/common/CustomDataTable";
import ExportCompareView from "../components/exportshipement/ExportCompareView";
import CompareOutlinedIcon from '@mui/icons-material/CompareOutlined';



const title = 'Export Shipment';

const ExportShipment = () => {
  const companyDateFormat = useCompanyDateFormat();
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [exportShipments, setExportShipments] = useState([]);
  const [cifFobList, setCIFFOBList] = useState([]);
  const [shipmentTypes, setShipmentTypes] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [custumersList, setCustumersList] = useState([]);
  const [conutries, setConutries] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [portMasters, setPortMasters] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [newShippingId, setNewShippingId] = useState(null);
  const [expShipmentId, setExpShipmentId] = useState(null);
  const [permission, setPermissions] = useState()
  const [page, setPage] = useState(0); // UI 0-based
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const [exportShipmentId, setexportShipmentId] = useState('');
  const [colorlist, setColorlist] = useState([]);
  const [filterPayload, setFilterPayload] = useState({
    customerId: '',
    shipmentId: '',
    cifFobId: '',
    currencyId: '',
    shipmentTypeId: '',
    fromDate: '',
    toDate: '',
  });
  const { token } = useContext(AuthContext)
  const [activeButton, setActiveButton] = useState(null);
  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: ''
  });
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [rowId, setRowId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const filterOpen = () => setOpenDrawer(true);
  const filterClose = () => setOpenDrawer(false);



  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleUpdateClick = (exportShipmentId) => {
    setSelectedId(exportShipmentId);
    setUpdateModal(true);
  };

  const handleOpenDeleteAlert = (rowId) => {
    setDeleteAlert(true);
    setRowId(rowId);
  };

  const handleCloseUpdate = () => {
    setUpdateModal(false);
  };
  const handleFilterChange = (field, value) => {
    setFilterPayload((prev) => ({
      ...prev,
      [field]: value || '',
    }));
  };
  const handleFOBClick = () => {
    setActiveButton("2");
    setFilterPayload((prev) => ({
      ...prev,
      cifFobId: "1",
    }));
    fetchExportShipments();
  };
  const handleCIFClick = () => {
    setActiveButton("1");
    setFilterPayload((prev) => ({
      ...prev,
      cifFobId: "2",
    }));
    fetchExportShipments();
  };

  const handleClearFilters = useMemo(() => {
    return () => {
      setFilterPayload({
        customerId: '',
        shipmentId: '',
        cifFobId: '',
        currencyId: '',
        shipmentTypeId: '',
        fromDate: '',
        toDate: '',
      });
      fetchExportShipments(0, pageSize, '');
      setActiveButton(null);
    };
  }, [pageSize]);


  const handleDelete = async (exportShipmentId) => {
    setLoading(true);
    const authToken = sessionStorage.getItem('accessToken');
    try {
      const response = await axios.delete(DELETE_EXPORT_SHIPMENT(exportShipmentId), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        fetchExportShipments();
        setDeleteAlert(false);
        setMessage({
          open: true,
          text: response?.data?.message || "Delete successfully",
          type: "success",
        });
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error deleting export shipment", error);
    }
  };

  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
    let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
    let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
    setPermissions({
      edit: editPermision,
      delete: deletePermission
    })
  }, [])

  useEffect(() => {
    fetchExportShipments(page, pageSize)
  }, [token, page, pageSize, colorlist])


  useEffect(() => {
    getCommonData();
  }, []);

  const getCommonData = async () => {

    const cifFobListData = await getCIFFOBList();
    setCIFFOBList(cifFobListData);

    const shipmentTypesData = await getShipmentTypes();
    setShipmentTypes(shipmentTypesData);

    const currencyListData = await getCurrencyList();
    setCurrencyList(currencyListData);

    const custumersList = await getCustumersList();
    setCustumersList(custumersList);
    const getConutriesData = await getCountries()
    setConutries(getConutriesData)
    const getPaymentMethodData = await getPaymentMethod()
    setPaymentMethod(getPaymentMethodData);
    const getPortMastersData = await getPortMasters()
    setPortMasters(getPortMastersData);
    const colorData = await getColorPlate();
    setColorlist(colorData);
  }


  const columns = useMemo(
    () => [
      { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
      { accessorKey: "shipmentDate", header: "Date", size: 100, tableStyle: { textAlign: "center" }, enableSorting: false, },
      { accessorKey: "shipmentId", header: "Shipment ID", size: 50, tableStyle: { textAlign: "center" }, enableSorting: false, },
      {
        accessorKey: "customerName", header: "Customer Name", size: 200, enableSorting: false, tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "country",
        header: "Country",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.country}
              sx={{
                backgroundColor: row.original.countryIdBackground,
                color: row.original.countryIdColor,
                border: `1px solid ${row.original.countryIdColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },

      {
        accessorKey: "paymentMethodName",
        header: "Payment Method",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.paymentMethodName}
              sx={{
                backgroundColor: row.original.paymentBgColor,
                color: row.original.paymentColor,
                border: `1px solid ${row.original.paymentColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },
      { accessorKey: "noOfContainer", header: "No. of Container", size: 50, tableStyle: { textAlign: "center" }, enableSorting: false, },
      {
        accessorKey: "currency", header: "Currency", size: 50, enableSorting: false, tableHeader: {
          justifyContent: 'flex-start',
        },
      },

      {
        accessorKey: "loadingName",
        header: "Port Of Loading",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.loadingName}
              sx={{
                backgroundColor: row.original.portOfLoadingBackground,
                color: row.original.portOfLoadingColor,
                border: `1px solid ${row.original.portOfLoadingColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "destinationName",
        header: "Port Of Destination",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.destinationName}
              sx={{
                backgroundColor: row.original.portOfDestinationBackground,
                color: row.original.portOfDestinationColor,
                border: `1px solid ${row.original.portOfDestinationColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },


      {
        accessorKey: "cifFobName",
        header: "CIF/FOB",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.cifFobName}
              sx={{
                backgroundColor: row.original.cifFobBgColor,
                color: row.original.cifFobColor,
                border: `1px solid ${row.original.cifFobColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },

      {
        accessorKey: "compare",
        header: "compare",
        size: 100,
        enableSorting: false,
        Cell: ({ row }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
              <IconButton onClick={() => handleViewClick(row.original.exportShipmentId)}>
                <CompareOutlinedIcon style={{ color: "#1976D2" }} />
              </IconButton>
            </div>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Action",
        size: 50,
        enableSorting: false,
        Cell: ({ row }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
              <IconButton onClick={() => handleViewClickView(row.original.exportShipmentId)}>
                <VisibilityIcon style={{ color: "#059212" }} />
              </IconButton>
              {permission?.edit &&
                <IconButton onClick={() => handleUpdateClick(row.original.exportShipmentId)}>
                  <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                </IconButton>
              }
              {permission?.delete &&
                <IconButton onClick={() => handleOpenDeleteAlert(row.original.exportShipmentId)}>
                  <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                </IconButton>}
            </div>
          </>
        ),
      },
    ],
    [permission]
  );

  const formatPortName = (port, country) => {
    return [port, country].filter(Boolean).join(", ");
  };


  const fetchExportShipments = async (pageIndex = 0, pageSize = 10) => {
    setLoading(true);
    try {
      const payload = {
        page: pageIndex + 1,
        limit: pageSize,
        ...filterPayload
      };
      const response = await genericPost(LIST_ALL_EXPORT_SHIPMENT, payload, {});

      if (response.data.success && response.data.shipments) {
        const { newShippingId, expShipmentId } = response.data;
        const shipmentData = response.data.shipments.map((shipment, index) => {
          const countryColorObj = getColorById(shipment?.customer?.billingCountry?.id, colorlist, {
            matchKey: "colorId",
            prefixLength: 1,
          });
          return {
            index: (index + 1).toString().padStart(2, '0'),
            exportShipmentId: shipment.exportShipmentId || '',
            createdAt: formatDate(shipment.createdAt) || '',
            expectedEtd: shipment?.expectedEtd || '',
            shipmentDate: companyDateFormat(shipment?.shipmentDate) || '',
            shipmentId: shipment.shipmentId || '',
            customerName: shipment.customer.clientCompanyName || '',
            country: shipment.customer.billingCountry.name || '',
            noOfContainer: shipment.noOfContainers || '',
            cifFob: shipment.cifFob.cifFobName || '',
            cifFobName: shipment.cifFob.cifFobName || '',
            cifFobId: shipment.cifFob.cifFobId || '',
            paymentMethodName: shipment?.paymentMethod?.paymentMethodName || '',
            cifFobColor: shipment.cifFob?.ColorPlate?.color || '',
            cifFobBgColor: shipment.cifFob?.ColorPlate?.backgroundColor || '',
            paymentColor: shipment?.paymentMethod?.ColorPlate?.color || '',
            paymentBgColor: shipment?.paymentMethod?.ColorPlate?.backgroundColor || '',
            currency: `${shipment.currency?.currency_symbol || ''} (${shipment.currency?.currency || ''}) - ${shipment.currency?.currency_name || ''}`,
            portOfLoading: shipment.portOfLoading || '',
            portOfDestination: shipment.portOfDestination || '',
            loadingName: formatPortName(
              shipment?.loading?.portName,
              shipment?.loading?.country?.name
            ),
            destinationName: formatPortName(
              shipment?.destination?.portName,
              shipment?.destination?.country?.name
            ),
            countryIdColor: countryColorObj.color || '',
            countryIdBackground: countryColorObj.backgroundColor || '',
            portOfLoadingColor: shipment?.loading?.ColorPlate?.color || '',
            portOfLoadingBackground: shipment?.loading?.ColorPlate?.backgroundColor || '',

            portOfDestinationColor: shipment?.destination?.ColorPlate?.color || '',
            portOfDestinationBackground: shipment?.destination?.ColorPlate?.backgroundColor || '',

          };
        });
        setExportShipments(shipmentData);
        setNewShippingId(newShippingId);
        setExpShipmentId(expShipmentId)
        setRowCount(response.data.pagination?.totalRecords || 0);

      } else {
        setError('No export shipments found');
      }
    } catch (error) {
      setError('Error fetching export shipments');
      console.error('Error fetching export shipments', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
  };
  const handleOpenView = (id) => {
    setexportShipmentId(id);
    setViewModal(true);
  };

  const handleCloseView = () => {
    setViewModal(false);
    setexportShipmentId('');
  };

  const handleViewClick = (id) => {
    handleOpenView(id);
  };

  const handleViewClickView = (exportShipmentId) => {
    navigate(`/app/export/shipementview/${exportShipmentId}`);
  };

  return (
    <>
      <Box sx={{ padding: '10px' }}>
        <CustomLoader open={loading} />
        <CustomDataTable
          title={title}
          columns={columns}
          data={exportShipments}
          handleOpen={handleOpen}
          buttonTitle="Create"
          handleFilterButton={filterOpen}
          fiterButtonTitile="Filter"
          rowCount={rowCount}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fromDate={filterPayload.fromDate || ""}
          toDate={filterPayload.toDate || ""}
        />
        <CustomModal open={modal}  >
          <Createexportshipement
            handleClose={handleClose}
            fetchExportShipments={fetchExportShipments}
            setMessage={setMessage}
            cifFobList={cifFobList}
            shipmentTypes={shipmentTypes}
            currencyList={currencyList}
            paymentMethod={paymentMethod}
            custumersList={custumersList}
            newShippingId={newShippingId}
            expShipmentId={expShipmentId}
            exportShipments={exportShipments}
            portMasters={portMasters}
          />
        </CustomModal>

        <CustomModal open={updateModal}  >
          <UpdateExportshipement
            handleClose={handleCloseUpdate}
            exportShipmentId={selectedId}
            fetchExportShipments={fetchExportShipments}
            setMessage={setMessage}
            cifFobList={cifFobList}
            shipmentTypes={shipmentTypes}
            paymentMethod={paymentMethod}
            currencyList={currencyList}
            custumersList={custumersList}
            portMasters={portMasters}
          />
        </CustomModal>

        <CustomModal
          open={viewModal}
          handleClose={handleCloseView}>
          <ExportCompareView
            handleClose={handleCloseView}
            exportShipmentId={exportShipmentId}
          />
        </CustomModal>

        <MessageBox
          open={message.open}
          onClose={() => setMessage({ ...message, open: false })}
          message={message.text}
          handleClose={() => setMessage({ ...message, open: false })}
          type={message.type}
        />
        <CustomDelete
          handleDelete={handleDelete}
          open={deleteAlert}
          rowId={rowId}
          handleClose={() => setDeleteAlert(false)}
        />
        <CustomFilter
          drawerTitle="Filter"
          drawerWidth={300}
          openDrawer={openDrawer}
          onClose={filterClose}
          drawerContent={
            <>
              <Box>
                <Grid container spacing={1} sx={{ padding: 0, }}>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      type="text"
                      placeholder="Enter Shipment ID"
                      value={filterPayload.shipmentId}
                      onChange={(e) => handleFilterChange('shipmentId', e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={custumersList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Customer"
                      value={custumersList.find((item) => item.id === filterPayload.customerId) || null}
                      onChange={(event, newValue) => handleFilterChange("customerId", newValue?.id)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={currencyList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Currency"
                      value={currencyList.find((item) => item.id === filterPayload.currencyId) || null}
                      onChange={(event, newValue) => handleFilterChange("currencyId", newValue?.id)}

                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="From Date"
                      type="date"
                      value={filterPayload.fromDate}
                      onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                      placeholder="From Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="To Date"
                      type="date"
                      value={filterPayload.toDate}
                      onChange={(e) => handleFilterChange('toDate', e.target.value)}
                      placeholder="To Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <CustomButton
                      onClick={handleCIFClick}
                      title="CIF"
                      size="small"
                      variant="outlined"
                      style={{
                        ...cif_fob_style,
                        ...(activeButton === "1" ? activeStyle : {}),
                      }}

                    />
                    <CustomButton
                      onClick={handleFOBClick}
                      title="FOB"
                      size="small"
                      variant="outlined"
                      style={{
                        ...cif_fob_style,
                        ...(activeButton === "2" ? activeStyle : {}),
                      }}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                    <CustomButton
                      startIcon={<FindReplaceOutlinedIcon />}
                      title="Apply"
                      size="small"
                      variant="contained"
                      onClick={fetchExportShipments}
                    />
                    <CustomButton
                      variant="outlined"
                      title="Clear"
                      startIcon={<ClearRounded />}
                      style={cif_fob_style}
                      onClick={handleClearFilters}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          }
        />
      </Box>
    </>
  );
};

export default ExportShipment;

const cif_fob_style = {
  backgroundColor: '#ffff',
  color: '#007bff',
  textTransform: "capitalize",
  borderRadius: 4,
  border: '1px solid #007bff',
  height: 30,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: "100px"

}
const activeStyle = {
  backgroundColor: "#007BFF",
  color: "#ffffff",
  border: "1px solid #007BFF",
};
